import React, { Fragment } from 'react';
import './loader.scss';
import loadingimg from '../../assets/images/talent.png';
const Loader = (props: any) => {
  const { showLoaderMessage } = props;
  return (
    <Fragment>
      <div className="overlay">
        <div className="overlay__inner">
          <div className="overlay__content">
            <div className="outer-circle">
              <div className="inner-circle">
                <span className="spinner">
                  <img src={loadingimg} alt="" />
                </span>
              </div>
            </div>

            {/* {showLoaderMessage &&
              <h5 className='mt-3 message'> We are looking for your books...</h5>
            } */}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default Loader;
